import React, { Component } from 'react';
import cx from 'classnames';
import _omit from 'lodash.omit';
import Icon from '../../Icon';
import { Image } from '../../Image';
import NavigationLink from './NavigationLink';
import { NAVIGATION_MENU_SIZE } from '../../../common/styles/vars';
import {
  LOGO_CONTAINER,
  LOGO,
  TOP_MENU_LINKS,
  BOTTOM_MENU_LINKS } from
'../styles/navMenu';
import Text from '../../Text';
import Button from '../../Button';
import Drawer from '../../Drawer';
import Dropdown from '../../Dropdown';

import '../styles/_nav-menu.scss';


































const NAV_OPEN_PREF = 'navMenuOpen';

export default class NavigationMenu extends Component {
  static displayName = 'NavigationMenu';

  static defaultProps = {
    hasLogo: true
  };

  constructor(props) {
    super(props);

    this.state = {
      minimised: false,
      expandedGroups: {}
    };
  }

  componentDidMount() {
    window.addEventListener('storage', this.onStorageChange);
  }

  componentWillUnmount() {
    window.removeEventListener('storage', this.onStorageChange);
  }

  onStorageChange = () => {
    const navOpenStatus = localStorage.getItem(NAV_OPEN_PREF);
    const isMinimised = Boolean(navOpenStatus);

    this.setState({ minimised: isMinimised });
  };

  onToggleExpanded = (minimised) => {
    localStorage.setItem(NAV_OPEN_PREF, minimised ? 'true' : '');
  };

  onPrimaryActionChanged = ({ value }) => {
    const { primaryButtonProps } = this.props;

    if (primaryButtonProps && primaryButtonProps.options) {
      const selectedOption = primaryButtonProps.options.
      find((option) => option.value === value);

      if (selectedOption) {
        selectedOption.action();
      }
    }
  };

  toggleGroup = (key, currentlyExpanded) => {
    this.setState((state) => ({
      expandedGroups: { ...state.expandedGroups, [key]: !currentlyExpanded }
    }));
  };

  renderNavLink = (route) => {
    if (route.subMenuRoutes) {
      return this.renderNavGroup(route);
    }

    const {
      label,
      icon,
      url,
      selected,
      onClick,
      className
    } = route;
    const {
      history,
      primaryLinksColour,
      primaryLinksHoverColour,
      primaryLinksSelectedColour
    } = this.props;
    const click = onClick || (() => history.push(url));

    return (
      <NavigationLink
        key={icon}
        onClick={click}
        label={label}
        selected={selected}
        icon={icon}
        className={className}
        linkColour={primaryLinksColour || 'denim'}
        linkHoverColor={primaryLinksHoverColour}
        linkSelectedColor={primaryLinksSelectedColour} />);


  };

  renderNavGroup = (route) => {
    const { label, icon, url, active, subMenuRoutes } = route;
    const {
      history,
      primaryLinksColour,
      primaryLinksHoverColour
    } = this.props;
    const { minimised, expandedGroups } = this.state;

    const groupActive = active || subMenuRoutes.some((child) => child.selected);
    // User toggles win; otherwise the group is auto-expanded while on a
    // child/parent route.
    const expanded =
      url in expandedGroups ? expandedGroups[url] : groupActive;

    const onParentClick = () => {
      history.push(url);
      this.toggleGroup(url, expanded);
    };

    return (
      <React.Fragment key={url}>
        <NavigationLink
          onClick={onParentClick}
          label={label}
          icon={icon}
          active={active}
          hasSubmenu={!minimised}
          expanded={expanded}
          linkColour={primaryLinksColour || 'denim'}
          linkHoverColor={primaryLinksHoverColour} />

        {!minimised &&
        expanded &&
        subMenuRoutes.map((child) =>
        <NavigationLink
          key={child.url}
          onClick={() => history.push(child.url)}
          label={child.label}
          icon={child.icon}
          selected={child.selected}
          indented
          rounded
          selectedColour="greenSnake"
          iconColour={child.iconColor}
          iconSize={child.iconSize}
          linkColour="denim"
          linkSelectedColor="lightGreen"
          linkHoverColor={primaryLinksHoverColour} />)}

      </React.Fragment>);

  };

  goToHome = () => {
    const { history } = this.props;

    history.push('/');
  };

  render() {
    const {
      topRoutes,
      bottomRoutes,
      isExpandable,
      logoUrl,
      primaryColour,
      title,
      primaryButtonProps,
      primaryLinksColour,
      hasLogo
    } = this.props;

    const { minimised } = this.state;

    return (
      <Drawer
        isExpandable={isExpandable}
        menuColor={primaryColour}
        startOpen={!localStorage.getItem(NAV_OPEN_PREF)}
        onToggleExpanded={this.onToggleExpanded}
        align="left"
        minimisedWidth={80}
        showExpandOnHover
        renderChildrenMinimised
        width={NAVIGATION_MENU_SIZE.default}
        isMinimised={minimised}>

        <div className="nav__menu-container">
          {hasLogo &&
          <div className={cx('nav__menu__logo', LOGO_CONTAINER(false))}>
              <button type="button" onClick={this.goToHome} className={LOGO(false)} style={{ color: primaryLinksColour }}>
                {
              logoUrl ?
              <Image width="35px" height="35px" imageUrl={logoUrl} backgroundSize="cover" /> :
              <Icon name="shootstacolour" size={35} />}

                <Text heading4 noMargin>{title}</Text>
              </button>
            </div>}

          {
          primaryButtonProps && !primaryButtonProps.isDropdownButton ?

          <div
            className="nav__menu__primary-action nav__menu__primary-action__btn"
            style={{ color: primaryLinksColour }}>

                  <Button
              {..._omit(primaryButtonProps, 'children')}
              type="TERTIARY"
              prefix="addfat"
              prefixSize={15} />

                  <Text button noMargin>{primaryButtonProps.children || []}</Text>
                </div> :
          null}

          {
          primaryButtonProps && primaryButtonProps.isDropdownButton ?

          <div className="nav__menu__primary-action" style={{ color: primaryLinksColour }}>
                  <Dropdown
              isExpandIconVisible={false}
              type="BUTTON"
              onChange={this.onPrimaryActionChanged}
              value={{
                label: primaryButtonProps.label,
                value: 'default',
                prefix: primaryButtonProps.prefix || '',
                prefixSize: 20
              }}
              options={primaryButtonProps.options ?
              primaryButtonProps.options.map((option) => ({
                label: option.label,
                value: option.value,
                prefix: option.prefix,
                prefixSize: 15
              })) :
              []}

              menuWidth={200} />

                </div> :
          null}

          <div className={cx('nav__menu__top-links', TOP_MENU_LINKS(false))}>
            {topRoutes.map(this.renderNavLink)}
          </div>
          {
          bottomRoutes ?

          <div className={cx('nav__menu__bottom-links', BOTTOM_MENU_LINKS(false))}>
                  {bottomRoutes.map(this.renderNavLink)}
                </div> :

          null}

        </div>
      </Drawer>);

  }
}